// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const PercentageCircleIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "PercentageCircle/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10 1.667A8.336 8.336 0 0 0 1.667 10c0 4.6 3.733 8.333 8.333 8.333S18.333 14.6 18.333 10 14.6 1.667 10 1.667ZM7.275 6.383c.675 0 1.233.55 1.233 1.234 0 .675-.55 1.233-1.233 1.233-.675 0-1.233-.55-1.233-1.233 0-.684.55-1.234 1.233-1.234Zm.1 6.784a.618.618 0 0 1-.442.183.618.618 0 0 1-.441-.183.629.629 0 0 1 0-.884l5.458-5.458a.629.629 0 0 1 .883 0 .629.629 0 0 1 0 .883l-5.458 5.459Zm5.35.45c-.675 0-1.233-.55-1.233-1.234 0-.675.55-1.233 1.233-1.233.675 0 1.233.55 1.233 1.233a1.23 1.23 0 0 1-1.233 1.234Z"
}));
export default PercentageCircleIcon;